<template>
  <div class="parking-rule">
  <el-form ref="form" :model="form" class="form">
    <el-form-item label="商场名称">
          <el-select v-model="form.mallId" placeholder="请选择商场名称">
            <el-option v-for="item in mallOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
    </el-form-item>
  </el-form>
    <div class="market-check-index">
    <el-tabs v-model="activeName" type="card" :closable="false">
      <el-tab-pane label="车场配置" name='ParkingConfiguration'>
        <div class="tab-content">
          <ParkingConfiguration :mallId="form.mallId" v-if="form.mallId"></ParkingConfiguration>
        </div>
      </el-tab-pane>
      <el-tab-pane label="积分抵扣" name="PointDeduction">
        <div class="tab-content">
          <PointDeduction :mallId="form.mallId"  v-if="form.mallId"></PointDeduction>
        </div>
      </el-tab-pane>
      <el-tab-pane label="会员权益抵扣" name="CreditDuration">
        <div class="tab-content">
          <CreditDuration :mallId="form.mallId" v-if="form.mallId"></CreditDuration>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</div>
</template>
<script>
import {api_getConfig} from '@/api/common'
import AuthButton from '@/components/AuthButton'
import PointDeduction from './components/pointDeduction'
import ParkingConfiguration from './components/parkingConfiguration'
import CreditDuration from './components/creditDuration'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "parkingRule",
  components: {
    AuthButton,
    Search,
    Table,
    PointDeduction,
    ParkingConfiguration,
    CreditDuration
  },
  data() {
    return {
      mallOption:[],
      form: {
        mallId:''
      },
      activeName:'ParkingConfiguration',
    };
  },
  created () {
    this.getMallList()
  },
  
  methods: {
     // 获取消费店铺数据
    async getMallList() {
      let res = await api_getConfig('mall')
      let arr = res.mall.map(item => {
        return {
          label: item.name,
          value: item.id + ''
        }
      })
      this.form.mallId = arr[0].value
      this.mallOption = arr
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-check-index {
  width: 100%;
  padding: 35px 20px;
  box-sizing: border-box;
  .tab-content {
    margin-top: -30px;
  }
}
.parking-rule {
  width: 100%;
  box-sizing: border-box;
  ::v-deep{
    .search-box{
      margin-top: 20px;
    }
  }
  .el-form{
    margin: 20px;
  }
  .fun-btn-box {
    margin-top: 20px;
  }
  .today-sum{
    margin-top: 35px;
    display: flex;
    justify-content: space-between;
    .today-sum-item{
      height: 90px;
      width: calc(50% - 7.5px);
      display: flex;
      align-items: center;
      .item-icon{
        margin-left: 50px;
        margin-right: 20px;
        img{
          width: 46px;
          height: 46px;
        }
      }
      .item-content{
        p{
          margin: 0;
        }
        .title{
          font-size: 12px;
          color: #666666;
          margin-bottom: 15px;
        }
        .amount{
          font-size: 24px;
          font-weight: 500;
          color: #333333;
        }
        .tips{
          font-size: 12px;
          color: #666666;
          font-weight: 400;
        }
      }
    }
  }
  *::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }
  *::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
    background: #dcdfe6;
  }
  *::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
    border-radius: 10px;
    background: #fafafa;
  }
  .fun-btn-box {
    margin-top: 20px;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
  }
  .Billing, .Paying{
    background: #3775FF;
    border-radius: 50%;
    vertical-align: middle;
  }
  .Left{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .tipsA{
    font-size: 13px;
    color: #FF8E12;
  }
  .tipsB{
    font-size: 13px;
    color: #999;
  }
  ::v-deep{
    .el-table__body-wrapper::-webkit-scrollbar{
      /*滚动条整体样式*/
      width: 4px !important; /*高宽分别对应横竖滚动条的尺寸*/
      height: 5px !important;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
      background: #dcdfe6;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
      border-radius: 10px;
      background: #fafafa;
    }
    .el-table__fixed{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
    .el-table__fixed-right{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
  }
  .image{
    width: 60px;
    height: 60px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
}
</style>
